import { JobsType as ApiJobsType } from 'src/api/generated/touring/types';
import { JobsType } from '../../types';
import { mapJob } from './helpers';

export const mapJobs = (jobs: ApiJobsType): JobsType => {
  return {
    tourProd: mapJob(jobs.tourProd),
    tourRep: mapJob(jobs.tourRep),
    tourAcc: mapJob(jobs.tourAcc),
    tourSec: mapJob(jobs.tourSec),
    tourVip: mapJob(jobs.tourVip),
    localProd: mapJob(jobs.localProd),
    localTicketing: mapJob(jobs.localTicketing),
    localRepAcc: mapJob(jobs.localRepAcc),
  };
};
